import { inject, Injectable } from '@angular/core';
import { DefaultHttpUrlGenerator, HttpResourceUrls, normalizeRoot, Pluralizer } from '@ngrx/data';

import { LocalStorageService, StorageKey } from '@blaze-shared/platform-data-access';

const PARAM_KEYS: { [key: string]: StorageKey } = {
  ':accountid': StorageKey.AccountId,
};

@Injectable({ providedIn: 'root' })
export class AppHttpUrlGenerator extends DefaultHttpUrlGenerator {
  private localStorageService = inject(LocalStorageService);

  private plural: Pluralizer;

  constructor() {
    const plural = inject(Pluralizer);

    super(plural);

    this.plural = plural;
  }

  /**
   * Replaces a parameter in the URL with a value from local storage.
   * @param url
   * @returns
   */
  replaceUrlParams(url: string): string {
    for (const key in PARAM_KEYS) {
      if (url.indexOf(key) >= 0) {
        const storageKey: StorageKey = PARAM_KEYS[key];
        const value = this.localStorageService.get<string>(storageKey) || '';
        url = url.replace(key, value);
      }
    }
    return url;
  }

  protected getResourceUrls(entityName: string, root: string): HttpResourceUrls {
    let resourceUrls = this.knownHttpResourceUrls[entityName];
    if (!resourceUrls) {
      const nRoot = normalizeRoot(root);
      const url = `${nRoot}/${this.plural.pluralize(entityName)}/`?.toLowerCase();
      resourceUrls = {
        entityResourceUrl: url,
        collectionResourceUrl: url,
      };
      this.registerHttpResourceUrls({ [entityName]: resourceUrls });
    }
    const parametrizedResourceUrls: HttpResourceUrls = {
      collectionResourceUrl: this.replaceUrlParams(resourceUrls.collectionResourceUrl),
      entityResourceUrl: this.replaceUrlParams(resourceUrls.entityResourceUrl),
    };
    return parametrizedResourceUrls;
  }
}
